module.exports = __webpack_public_path__ + "img/authenticationOrange.9ef23524.png";